import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-068ecfbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<figure class=\"navbar__logo\" data-v-068ecfbe><img src=\"" + _imports_0 + "\" alt=\"\" data-v-068ecfbe></figure><div class=\"navbar__links\" data-v-068ecfbe><a href=\"\" data-v-068ecfbe>Features</a><a href=\"\" data-v-068ecfbe>Team</a><a href=\"\" data-v-068ecfbe>Sign in</a></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, _hoisted_4))
}